import parkBanner from '../../assets/images/banner/parkIntroductionBanner.png'
import policiesBanner from '../../assets/images/banner/policiesBanner.png'
import incubationBanner from '../../assets/images/banner/incubationBanner.png'
import applyBanner from '../../assets/images/banner/applyBanner.png'
const state = {
  // baseUrl:'http://fhy.gzbige.com',
  //http://192.168.0.108:8090/
  //http://fhy.gzbige.com/
  static: [
    {
      menuId: 8,
      menuName: "园区概况",
      banner:parkBanner,
      cnTitle: '园区概况',
      enTitle: 'Park overview',
      children: [
        {
          id: 2,
          plateName: '园区介绍'
        }, {
          id: 1,
          plateName: '服务设施'
        }, {
          id: 3,
          plateName: "组织架构",
        }, {
          id: 4,
          plateName: "地理位置",
        },{
          id:5,
          plateName: "园区荣誉",
        }
      ]
    },
    {
      menuId: 18,
      menuName: "政策法规",
      banner:policiesBanner,
      cnTitle: '政策法规',
      enTitle: 'Policies and regulations',
      /*children: [
        {
          id: 10,
          plateName: '常用政策'
        }, {
          id: 11,
          plateName: '区域政策'
        }, {
          id: 12,
          plateName: '国家政策'
        }
      ]*/
      children: [
        {
          id: 10,
          plateName: '最新政策'
        },{
          id: 11,
          plateName: '地方政策'
        },
      ]
    },
    {
      menuId: 21,
      menuName: '孵化服务',
      banner:incubationBanner,
      cnTitle:'孵化服务',
      enTitle:'Incubation service',
      /*children: [
        {
          id: 13,
          plateName: "公共培训服务",
        }, {
          id: 14,
          plateName: "创业导师",
        }, {
          id: 15,
          plateName: "专利事务",
        }, {
          id: 16,
          plateName: "科技金融",
        }, {
          id: 17,
          plateName: "法律法务",
        }, {
          id: 18,
          plateName: "会计事务",
        }, {
          id: 19,
          plateName: "人力资源",
        }
      ]*/
      children: [
        /*{
          id: 13,
          plateName: "公共培训服务",
        },*/ {
          id: 14,
          plateName: "创业导师",
        }, {
          id: 13,
          plateName: "知识产权",
        } ,{
          id: 16,
          plateName: "科技金融",
        }, /*{
          id: 17,
          plateName: "法律法务",
        },*//* {
          id: 18,
          plateName: "会计事务",
        },*/{
          id: 18,
          plateName: "会计法务",
        },{
          id: 19,
          plateName: "人力资源",
        }
      ]
    },
    {
      menuId: 15,
      menuName: "入园申请",
      banner:applyBanner,
      cnTitle:'入园申请',
      enTitle:'Application for admission',
      children: [
        {
          id: 7,
          plateName: '申请入驻'
        }, {
          id: 8,
          plateName: '续租/调整/离园手续'
        }, {
          id: 9,
          plateName: '毕业认定标准'
        }
      ]
    },{
      menuId: 30,
      menuName: "高校科研院所专利及科技成果",
      banner: applyBanner,
      cnTitle: '高校科研院所专利及科技成果',
      enTitle: 'Scientific and technological patent achievements',
      children: [
        {
          id: 31,
          plateName: '院校机构',
          isPdf: true
        }, {
          id: 32,
          plateName: '所有专利'
        }
      ]
    },{
      //最后一项不显示在头部导航
      menuId: 29,
      menuName: "工作动态",
      banner:applyBanner,
      cnTitle:'工作动态',
      enTitle:'Work Dynamics',
      children: [
        {
          id:22,
          plateName: '工作动态'
        }, {
          id: 23,
          plateName: '公示公告'
        }
      ]
    }
  ],

}
const mutations = {}
const actions = {}
const getters = {}
export default {
  state,
  mutations,
  actions,
  getters
}
